import React from 'react'
import {Spacer} from '../../../../Common/Components/Spacer'
import {ErrorSummaryCard, ErrorSummaryHeadline} from './ErrorSummary/ErrorSummary'
import styled from '@emotion/styled'
import {Color} from '../../Styles'

type Props = {
  headline: string
  alertMessages: string[]
}
export const AlertList: React.VFC<Props> = (props) => {
  return (
    <AlertListCard>
      <Spacer mb={'10px'}>
        <ErrorSummaryHeadline headline={props.headline}/>
      </Spacer>
      <ul className="list-disc_01 fts13">
        {props.alertMessages.map((alertMessage, i) => {
          return <li key={i}>{alertMessage}</li>
        })}
      </ul>
    </AlertListCard>
  )
}

const AlertListCard = styled(ErrorSummaryCard)`
  background: ${Color.ErrorInputBackgroundColor};
`
